import Layout from '@/apps/layout/components'
import MediaDetail from '@/apps/MediaDetail'
import React from 'react'

const MediaDetailPage = (): React.ReactElement => {
  return (
    <Layout>
      <MediaDetail />
    </Layout>
  )
}

export default MediaDetailPage
